import React from 'react';
import Select from './Select'

const Country = (props) => {
    const {field} = props;
    const values = [
        {label: "Select Country"},
        {value: "Select Country"},
    ]


return (<Select field={{...field, options: values}} />)
}

export default Country;
